// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --ion-background-color: #f6f1ef;
}

.sign-up-button {
  --background: var(--color-white-accent);
  color: var(--color-black);
  --border-color: var(--color-black);
  --border-width: 1px;
  --border-style: solid;
}
@media (min-width: 991px) {
  .sign-up-button {
    min-height: 64px;
    margin-bottom: 12px;
    font-size: 20px;
  }
}

ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-item {
  --border-width: 1px !important;
  --border-radius: 52px !important;
  --border-color: #272727;
  --border-bottom: none;
  border: none;
  padding-inline: 3%;
}
ion-item:not(:last-child) {
  margin-bottom: 12px;
}

@media (min-width: 991px) {
  ion-item.password {
    margin-bottom: 40px;
  }
}

.forgot-password {
  margin: 20px 0;
  cursor: pointer;
  text-align: center;
}
.forgot-password h3 {
  color: var(--color-black) !important;
  font-size: 20px;
  text-transform: uppercase;
  text-decoration: underline;
  font-family: AppFontMedium, sans-serif;
}

.wrapper {
  padding: 25px;
}
@media (max-width: 992px) {
  .wrapper {
    padding: 50px 7px 20px;
  }
}

.stacked {
  position: relative;
  top: -10px;
  left: 0%;
  z-index: 2;
  left: 3%;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--color-black);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
@media (max-width: 992px) {
  ion-label {
    font-family: AppFontSemiBold;
    font-size: 14px;
  }
}

.main-button {
  margin-top: 40px;
}
@media (min-width: 991px) {
  .main-button {
    margin-top: 0px;
    min-height: 64px;
    font-size: 20px;
    margin-bottom: 26px;
  }
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.button-wrapper ion-button {
  width: 100%;
  margin: 10px 0px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
@media (min-width: 991px) {
  .button-wrapper ion-button {
    min-height: 64px;
    font-size: 20px;
  }
  .button-wrapper ion-button:not(:last-child) {
    margin-bottom: 12px;
  }
}
.button-wrapper ion-button p {
  font-family: AppFontMedium, sans-serif;
  color: white;
  width: 75%;
}
@media (min-width: 991px) {
  .button-wrapper ion-button p {
    width: -moz-fit-content;
    width: fit-content;
  }
}
.button-wrapper ion-button ion-icon {
  margin-right: 10px;
  zoom: 0.9;
}
@media (min-width: 991px) {
  .button-wrapper ion-button ion-icon {
    margin-right: 10px;
    zoom: 1;
  }
}
.button-wrapper ion-button.google {
  --background: transparent;
}
.button-wrapper ion-button.google p {
  color: var(--color-black);
}
.button-wrapper ion-button.facebook {
  --background: #3b5997;
}
.button-wrapper ion-button.apple {
  --background: var(--color-black);
}

.wrapper-modal {
  height: 100%;
  position: relative;
  overflow: auto;
  overflow-x: hidden;
  background: #f6f1ef;
}
.wrapper-modal ion-item {
  --background: #f6f1ef;
}
.wrapper-modal .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 25px;
  height: 25px;
  z-index: 99;
}
@media (min-width: 991px) {
  .wrapper-modal .close-icon {
    display: none;
  }
}
.wrapper-modal .big-close-icon {
  cursor: pointer;
  position: absolute;
  top: 15px;
  right: 15px;
  width: 50px;
  height: 50px;
  z-index: 99;
}
@media (max-width: 992px) {
  .wrapper-modal .big-close-icon {
    display: none;
  }
}
.wrapper-modal .title-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFontMedium, sans-serif;
  font-size: 15px;
  letter-spacing: 0.08em;
  margin-bottom: 30px;
}
@media (min-width: 991px) {
  .wrapper-modal .title-text {
    font-family: AppFontBold, sans-serif;
    font-size: 32px;
    padding-top: 25px;
  }
}
.wrapper-modal .subtitle-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  letter-spacing: 0.08em;
  text-wrap: balance;
  font-size: 12px;
  margin-bottom: 20px;
}
@media (min-width: 991px) {
  .wrapper-modal .subtitle-text {
    font-size: 20px;
    margin-bottom: 40px;
  }
}
.wrapper-modal .or {
  margin: 10px 0 30px;
}
.wrapper-modal .header-block {
  padding: 20px;
  border-bottom: 1px solid var(--color-black);
}
@media (min-width: 991px) {
  .wrapper-modal .header-block {
    padding: 40px 40px 0px;
  }
}
.wrapper-modal .footer-block {
  padding: 20px;
}
@media (min-width: 991px) {
  .wrapper-modal .footer-block {
    padding: 20px 40px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/sign-in/sign-in.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,+BAAA;AADF;;AAIA;EACC,uCAAA;EACA,yBAAA;EACA,kCAAA;EACA,mBAAA;EACA,qBAAA;AADD;ACTE;EDKF;IAOI,gBAAA;IACA,mBAAA;IACA,eAAA;EACF;AACF;;AAEA;EACC,6BAAA;AACD;;AACA;EACC,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACC,kBAAA;AAEF;AACC;EACC,mBAAA;AACF;;AChCE;EDoCF;IAEI,mBAAA;EADF;AACF;;AAIA;EACC,cAAA;EACA,eAAA;EACA,kBAAA;AADD;AAEC;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,sCAAA;AAAF;;AAGA;EAIC,aAAA;AAHD;ACjDE;EDgDF;IAEI,sBAAA;EAGF;AACF;;AACA;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EAEC,QAAA;AACF;;AAGA;EACC,eAAA;EACA,mBAAA;AAAD;;AAGA;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACC,sBAAA;AAAF;AC3EE;EDsEF;IAQI,4BAAA;IACA,eAAA;EACF;AACF;;AAEA;EACE,gBAAA;AACF;AC3FE;EDyFF;IAGI,eAAA;IACF,gBAAA;IACE,eAAA;IACA,mBAAA;EAGF;AACF;;AAAA;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AAGD;AADC;EACC,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAGF;ACjHE;EDyGD;IAQK,gBAAA;IACA,eAAA;EAIJ;EAHI;IACE,mBAAA;EAKN;AACF;AAFE;EACC,sCAAA;EACA,YAAA;EACA,UAAA;AAIH;AC/HE;EDwHA;IAMM,uBAAA;IAAA,kBAAA;EAKN;AACF;AAHE;EACC,kBAAA;EACA,SAAA;AAKH;ACxIE;EDiIA;IAIM,kBAAA;IACA,OAAA;EAON;AACF;AALE;EACC,yBAAA;AAOH;AANG;EACC,yBAAA;AAQJ;AALE;EACC,qBAAA;AAOH;AALE;EACC,gCAAA;AAOH;;AAHA;EAEC,YAAA;EACA,kBAAA;EACA,cAAA;EACC,kBAAA;EACD,mBAAA;AAKD;AAJC;EACC,qBAAA;AAMF;AAJC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAMF;AC7KE;EDiKD;IASE,aAAA;EAOD;AACF;AALC;EACC,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAOF;ACrLE;EDuKD;IAUE,aAAA;EAQD;AACF;AANC;EACC,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACE,mBAAA;AAQJ;AC1ME;ED0LD;IAUE,oCAAA;IACA,eAAA;IAEA,iBAAA;EASD;AACF;AAPC;EACC,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gCAAA;EACA,sBAAA;EACA,kBAAA;EACE,eAAA;EACA,mBAAA;AASJ;AC5NE;ED0MD;IAYE,eAAA;IACA,mBAAA;EAUD;AACF;AAPE;EACE,mBAAA;AASJ;AAPC;EACC,aAAA;EACA,2CAAA;AASF;ACzOE;ED8ND;IAIE,sBAAA;EAWD;AACF;AATC;EACC,aAAA;AAWF;ACjPE;EDqOD;IAGE,uBAAA;EAaD;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n  --ion-background-color: #f6f1ef;\n}\n\n.sign-up-button {\n\t--background: var(--color-white-accent);\n\tcolor: var(--color-black);\n\t--border-color: var(--color-black);\n\t--border-width: 1px;\n\t--border-style: solid;\n  @include desktop {\n    min-height: 64px;\n    margin-bottom: 12px;\n    font-size: 20px;\n  }\n}\n\nion-item.input-error {\n\tmargin-bottom: 8px !important;\n}\nion-item {\n\t--border-width: 1px !important;\n\t--border-radius: 52px !important;\n\t--border-color: #272727;\n\t--border-bottom: none;\n\tborder: none;\n  padding-inline: 3%;\n\n\n\t&:not(:last-child) {\n\t\tmargin-bottom: 12px;\n\t}\n\n}\n\nion-item.password {\n  @include desktop {\n    margin-bottom: 40px;\n  }\n}\n\n.forgot-password {\n\tmargin: 20px 0;\n\tcursor: pointer;\n\ttext-align: center;\n\th3 {\n\t\tcolor: var(--color-black) !important;\n\t\tfont-size: 20px;\n\t\ttext-transform: uppercase;\n\t\ttext-decoration: underline;\n\t\tfont-family: AppFontMedium, sans-serif;\n\t}\n}\n.wrapper {\n  @include mobile {\n    padding: 50px 7px 20px;\n  }\n\tpadding: 25px;\n}\n\n.stacked {\n\tposition: relative;\n\ttop: -10px;\n\tleft: 0%;\n\tz-index: 2;\n\n  left: 3%;\n\n}\n\nion-note {\n\tfont-size: 12px;\n\tpadding-right: 10px;\n}\n\nion-label {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 16px;\n\tcolor: var(--color-black);\n\ttext-transform: uppercase;\n  letter-spacing: 0.08em;\n\n  @include mobile {\n    font-family: AppFontSemiBold;\n    font-size: 14px;\n  }\n}\n\n.main-button {\n  margin-top: 40px;\n\t@include desktop {\n    margin-top: 0px;\n\t\tmin-height: 64px;\n    font-size: 20px;\n    margin-bottom: 26px;\n\t}\n}\n\n.button-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\twidth: 100%;\n\n\tion-button {\n\t\twidth: 100%;\n\t\tmargin: 10px 0px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\n    @include desktop {\n      min-height: 64px;\n      font-size: 20px;\n      &:not(:last-child) {\n        margin-bottom: 12px;\n      }\n    }\n\n\t\tp {\n\t\t\tfont-family: AppFontMedium, sans-serif;\n\t\t\tcolor: white;\n\t\t\twidth: 75%;\n\n      @include desktop {\n        width: fit-content;\n      }\n\t\t}\n\t\tion-icon {\n\t\t\tmargin-right: 10px;\n\t\t\tzoom: 0.9;\n      @include desktop {\n        margin-right: 10px;\n        zoom: 1;\n      }\n\t\t}\n\t\t&.google {\n\t\t\t--background: transparent;\n\t\t\tp {\n\t\t\t\tcolor: var(--color-black);\n\t\t\t}\n\t\t}\n\t\t&.facebook {\n\t\t\t--background: #3b5997;\n\t\t}\n\t\t&.apple {\n\t\t\t--background: var(--color-black);\n\t\t}\n\t}\n}\n.wrapper-modal {\n\n\theight: 100%;\n\tposition: relative;\n\toverflow: auto;\n  overflow-x: hidden;\n\tbackground: #f6f1ef;\n\tion-item {\n\t\t--background: #f6f1ef;\n\t}\n\t.close-icon {\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tz-index: 99;\n\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t.big-close-icon {\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\twidth: 50px;\n\t\theight: 50px;\n\t\tz-index: 99;\n\n\t\t@include mobile {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t.title-text {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t\tfont-family: AppFontMedium, sans-serif;\n\t\tfont-size: 15px;\n\t\tletter-spacing: 0.08em;\n    margin-bottom: 30px;\n\t\t@include desktop {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tfont-size: 32px;\n\n\t\t\tpadding-top: 25px;\n\t\t}\n\t}\n\t.subtitle-text {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t\tfont-family: AppFont, sans-serif;\n\t\tletter-spacing: 0.08em;\n\t\ttext-wrap: balance;\n    font-size: 12px;\n    margin-bottom: 20px;\n\n\t\t@include desktop {\n\t\t\tfont-size: 20px;\n\t\t\tmargin-bottom: 40px;\n\t\t}\n\t}\n\n  .or {\n    margin: 10px 0 30px ;\n  }\n\t.header-block {\n\t\tpadding: 20px;\n\t\tborder-bottom: 1px solid var(--color-black);\n\t\t@include desktop {\n\t\t\tpadding: 40px 40px 0px;\n\t\t}\n\t}\n\t.footer-block {\n\t\tpadding: 20px;\n\t\t@include desktop {\n\t\t\tpadding: 20px 40px 20px;\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
